module.exports = __webpack_public_path__ + "static/logo-8300a56e034d6c5d7c446abd13bc431f.png";